<template>
    <div class="cst-survey-card-finished">
       <span v-html="thanksText"></span>
       <img v-if="thanksImage" class="thanksImage" :src="thanksImage" />
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import BaseCardMixin from './BaseCardMixin.js'

    export default {
      mixins: [BaseCardMixin],
      created: function () {
        this.$store.dispatch('finishSurvey')
        eventHub.$emit('set-title', this.getTitle())
      },
      methods: {
        getTitle: function () {
          return this.$t('surveyFinishedTitle')
        }
      },
      computed: {
        thanksText: function () {
          return this.$store.state.hotelData.text.thanks
        },
        thanksImage: function () {
          return this.$store.state.hotelData.images.thanks
        }
      }
    }
</script>

<style scoped>
    h2 {
        text-align: center;
        margin: 0;
        padding: 0;
    }
    img {
      width: 100%;
      height: auto;
      margin-top: 1em;
      border: 1px solid #ccc;
      padding: 1px;
    }
</style>




// WEBPACK FOOTER //
// src/components/CardFinished.vue